// extracted by mini-css-extract-plugin
export default {"title":"termsList_title__ara+e","subtitle":"termsList_subtitle__L6Gvg","info":"termsList_info__nTXe6","link":"termsList_link__0ln4d"};